<template>
  <v-container fluid grid-list-md>
    <PageWrapper :title-has-padding-y="false" hideHeading>
        <v-tabs
          v-model="tabs"
          centered
          class="incomes-tabs"
          show-arrows
          >
          <v-tabs-slider></v-tabs-slider>
          <v-tab href="#y" class="primary--text">Год</v-tab>
          <v-tab href="#q" class="primary--text">Квартал</v-tab>
          <v-tab href="#m" class="primary--text">Месяц</v-tab>
          <v-tab href="#d" class="primary--text">Сутки</v-tab>
          <v-tab href="#r" class="primary--text">Период</v-tab>
        </v-tabs>

      <template v-if="tabs === 'r'">
        <div style="display: flex; justify-content: start; flex-wrap: wrap; gap: 0.25rem;">
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="dateFromPicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            z-index="100">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" outline class="incomes-date" style="border-radius: 5px">
                {{ dateFrom ? moment(dateFrom).format('DD.MM.YYYY') : 'Период с' }}
                <v-icon class="ml-3">calendar_month</v-icon>
              </v-btn>
            </template>
            <v-date-picker
              v-model="dateFrom"
              @input="dateFromPicker = false"
              locale="ru-RU"
              no-title
              scrollable>
            </v-date-picker>
          </v-menu>
          <v-menu
            lazy
            :close-on-content-click="false"
            v-model="dateToPicker"
            transition="scale-transition"
            offset-y
            full-width
            :nudge-right="40"
            min-width="290px"
            z-index="100">
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" outline class="incomes-date" style="border-radius: 5px">
                {{ dateTo ? moment(dateTo).format('DD.MM.YYYY') : 'Период По' }}
                <v-icon class="ml-3">calendar_month</v-icon>
              </v-btn>
            </template>
            <v-date-picker
              v-model="dateTo"
              @input="dateToPicker = false"
              locale="ru-RU"
              no-title
              scrollable>
            </v-date-picker>
          </v-menu>
          <v-btn color="primary" @click="getIncomesData">Обновить</v-btn>
        </div>
      </template>
      <v-divider class=""></v-divider>
      <div v-if="!preloader" class="incomes-wrapper">
          <div class="incomes-chart">
            <div class="mb-2">
              <v-chart
                ref="chartNode"
                v-if="displayedIncomes.data[tabs.toUpperCase()].length"
                style="width: 184px; height: 184px"
                key="incomes-pie"
                :option="incomesChart"
              />

              <div class="chart-info-box" v-if="!displayedIncomes.data[tabs.toUpperCase()].length">
                <v-layout align-center justify-center fill-height column>
                  <div class="noChart">
                    <v-icon class="grey--text text--lighten-1">data_usage</v-icon>
                    <p class="text-xs-center grey--text">Нет данных</p>
                  </div>
                </v-layout>
              </div>
            </div>
            <TableWrapper auto-scroll height="300px">
              <v-data-table
                :headers="headers"
                :items="incomes[tabs.toUpperCase()]"
                hide-actions
                class="elevation-0 small-table"
                no-data-text="Нет данных"
              >
                <template slot="items" slot-scope="props">
                  <tr  @click="changeChartState(props.item)" style="cursor: pointer">
                    <td>
                      <div style="display: flex;align-items: start">
                        <div
                          class="incomes-table-color mr-2 mt-1"
                          :class="[{'incomes-table-color_disabled': !!chartInverseStatus[props.item.AirlineName]}]"
                          v-if="props.item.AirlineName || !colors[props.index]"
                          :style="{'background-color': colors[props.index]}"
                        ></div>
                        {{ props.item.AirlineName || '*Без наименования*' }}
                      </div>
                    </td>
                    <td style="min-width: 150px">
                      {{
                        cur(props.item.Incomes)
                      }}
                    </td>
                    <td :class="[getGrowthClass(props.item)]" style="white-space: nowrap">
                      {{ props.item.Growth }} %
                      <v-icon
                        style="font-size: 16px"
                        medium
                        :class="getClass( props.item)"
                      >{{ getIcon( props.item) }}</v-icon>
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-divider class="mb-2"></v-divider>
            </TableWrapper>
          </div>
          <div class="d-flex">
            <v-divider vertical></v-divider>
            <div class="px-3 pb-3 pt-2">
              <div
                v-for="item in itemsCurrency"
                :key="item.title"
                class="incomes-incomes px-2 py-1 incomes-text"
                v-show="item.visible"
              >
                <div>
                  <div class="incomes-text_grey">{{item.title}}</div>
                  <div class="font-weight-bold incomes-text_dark">{{item.incomes}}</div>
                </div>
                <div class="font-weight-bold" :class="[getGrowthClass(item)]" style="text-align: right">
                  {{item.Growth}}%
                  <v-icon
                    style="font-size: 16px"
                    :title="parseInt(item.Growth) === 0 ? 'Нет данных для сравнения' : 'По отношению к аналогичному периоду прошлого года'"
                    medium
                    :class="getClass(item)"
                  >{{ getIcon(item) }}</v-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="preload-box h-100 pa-4" v-else>
        <v-progress-circular indeterminate :size="loaderSize" color="primary"></v-progress-circular>
      </div>
    </PageWrapper>

  </v-container>
</template>

<script>
import store from '@/store'
import { cur } from '../../helpers/currensy'
import PageWrapper from "../ui/PageWrapper.vue";
import TableWrapper from "../ui/TableWrapper.vue";
import moment from "moment";
export default {
  components: {TableWrapper, PageWrapper},
  data() {
    return {
      tabs: 'y',
      period: ['y', 'q', 'm', 'd', 'r'],
      chartTop: 5,
      dateFromPicker: false,
      dateToPicker: false,
      headers: [
        {
          text: 'Авиакомпания',
          align: 'left',
          sortable: false,
          value: 'AirlineName',
        },
        { text: 'Сборы, ₽', sortable: false, value: 'Incomes' },
        { text: 'Динамика', sortable: false, value: 'Growt' },
      ],
      chartInverseStatus:{},
      colors: ['#4caf50', '#FF9800', '#FF5722', '#2196f3', '#03A9F4', '#d1d1d1'],
    }
  },
  computed: {
    itemsCurrency() {
      return [
        {
          incomes: cur(this.getIncomesSum(this.incomes.Y)),
          Growth: this.growthY,
          visible: true,
          title: 'С начала года:',
        },
        {
          incomes: cur(this.getIncomesSum(this.incomes.Y)),
          Growth: this.growthQ,
          visible: true,
          title: 'С начала квартала:',
        },
        {
          incomes: cur(this.getIncomesSum(this.incomes.M)),
          Growth: this.growthM,
          visible: true,
          title: 'С начала месяца:',
        },
        {
          incomes: cur(this.getIncomesSum(this.incomes.D)),
          Growth: this.growthD,
          visible: this.tabs === 'd',
          title: 'Итого за сутки:',
        },
        {
          incomes: cur(this.getIncomesSum(this.incomes.R)),
          Growth: this.growthR,
          visible: this.tabs === 'r',
          title: 'Итого за период:',
        },
      ]
    },
    dateFrom: {
      get() {
        return store.getters['incomes/getDateFrom']
      },
      set(value) {
        store.commit('incomes/setDateFrom', value)
      },
    },
    dateTo: {
      get() {
        return store.getters['incomes/getDateTo']
      },
      set(value) {
        store.commit('incomes/setDateTo', value)
      },
    },
    incomes: {
      get() {
        return store.getters['incomes/getIncomes']
      },
      set(value) {
        store.commit('incomes/setIncomes', value)
      },
    },
    growthY: function () {
      return this.getIncomesGrowth(this.incomes.Y, this.incomes.prevYear)
    },
    growthM: function () {
      return this.getIncomesGrowth(this.incomes.M, this.incomes.prevYearMonth)
    },
    growthQ: function () {
      return this.getIncomesGrowth(this.incomes.Q, this.incomes.prevYearQuarter)
    },
    growthD: function () {
      return this.getIncomesGrowth(this.incomes.D, this.incomes.prevYearDay)
    },
    growthR: function () {
      return this.getIncomesGrowth(this.incomes.R, this.incomes.prevYearCustom)
    },
    displayedIncomes: function () {
      // Данные для отображения диаграммы (топ 5 АК)
      let data = this.incomes || {}
      let displayedIncomes = {}
      let legend = {}
      for (let key in data) {
        displayedIncomes[key] = data[key]
          .sort(function (a, b) {
            return b.Incomes - a.Incomes
          })
          .slice(0, this.chartTop)
        legend[key] = []
        let topSum = 0
        displayedIncomes[key].forEach(function (item, i, arr) {
          displayedIncomes[key][i] = {
            name: item.AirlineName,
            value: item.Incomes,
          }
          topSum += parseFloat(item.Incomes)
          legend[key].push(item.AirlineName)
        })
        // Добавим в диаграмму сумму остальных АК, не вошедших в топ
        if (data[key].length > this.chartTop) {
          let otherSum = 0
          otherSum = this.getIncomesSum(data[key]) - topSum
          displayedIncomes[key].push({
            name: 'Остальные',
            value: otherSum.toFixed(2),
          })
          legend[key].push('Остальные')
        }
      }
      return { data: displayedIncomes, legend: legend }
    },
    preloader: {
      get() {
        return store.getters['incomes/getIncomesPreloader']
      },
      set(value) {
        store.commit('incomes/setIncomesPreloaderState', value)
      },
    },
    incomesChart: function () {
      return {
        title: {
          text: 'Сборы',
          x: 'center',
        },
        tooltip: {
          trigger: 'item',
          position: 'right',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },

        legend: {
          show:false,
          orient: 'vertical',
          left: 0,//window.innerWidth > 1300 ? '25%' : 0,
          top:'15%',
          y: window.innerWidth > 1300 ? 'center' : 'bottom',
          textStyle: {
            fontSize: '11',
            fontFamily: 'Roboto',
          },
          data: this.displayedIncomes.legend[this.tabs.toUpperCase()],
        },
        color: ['#4caf50', '#FF9800', '#FF5722', '#2196f3', '#03A9F4', '#d1d1d1'],
        series: [
          {
            name: 'Сборы',
            type: 'pie',
            responsive: true,
            // radius: window.innerWidth > 1300 ? '60%' : '40%',
            // center: window.innerWidth > 1300 ? ['75%', '45%'] : ['85%', '50%'],
            hoverOffset: 1,
            avoidLabelOverlap: true,
            label: {
              show: false,
            },
            
            data: this.displayedIncomes.data[this.tabs.toUpperCase()],
          },
        ],
      }
    },
  },
  watch:{
    tabs() {
      this.chartInverseStatus = {}
    }
  },
  methods: {
    moment,
    getGrowthClass(row) {
      if (parseInt(row.Growth) === 0) {
        return ''
      }
      return row.Growth > 0 ? 'green--text' : 'red--text'
    },
    getClass(row) {
      if (parseInt(row.Growth) === 0) {
        return 'orange--text'
      }
      return row.Growth > 0 ? 'green--text' : 'red--text'
    },
    getIcon(row) {
      if (parseInt(row.Growth) === 0) {
        return 'history'
      }
      return row.Growth > 0 ? 'arrow_upward' : 'arrow_downward'
    },
    changeChartState(p) {
      !this.chartInverseStatus[p.AirlineName]
        ? this.$refs.chartNode.dispatchAction({
          type: 'legendUnSelect',
          name: p.AirlineName
        })
        : this.$refs.chartNode.dispatchAction({
          type: 'legendSelect',
          name: p.AirlineName
        })
      this.chartInverseStatus = {...this.chartInverseStatus, [p.AirlineName] :!this.chartInverseStatus[p.AirlineName]}
    },
    cur,
    getIncomesSum: function (arr) {
      arr = arr || []
      let sum = 0
      arr.forEach((element) => {
        sum += parseFloat(element.Incomes)
      })
      return sum.toFixed(2)
    },
    getIncomesGrowth: function (currentArr, prevArr) {
      let incomes = Math.round(this.getIncomesSum(currentArr))
      let prevIncomes = Math.round(this.getIncomesSum(prevArr))

      if (!prevIncomes) return 0

      let result = ((parseFloat(incomes) - parseFloat(prevIncomes)) / parseFloat(prevIncomes)) * 100

      return result.toFixed(0)
    },
    getIncomesData: function () {
      store.dispatch('incomes/updateIncomes', { PeriodStart: this.dateFrom, PeriodEnd: this.dateTo })
    },
  },
  mounted: function () {
    store.commit('setPageTitle', 'Сборы')
    store.dispatch('incomes/updateIncomes', {})
  },
}
</script>

<style scoped>
.chart-info-box {
  height: 220px;
  padding: 4px;
}
.noChart i {
  font-size: 110px;
}

.incomes-tabs {
  .v-tabs__item {
    color: #2196F3 !important;
    font-size: 16px;
    font-weight: 500;
    line-height: 22px;
    opacity: 1 !important;
  }
  .v-tabs__item--active {
    color: #5F6368 !important;
  }
}
.incomes-chart {
  display: grid;
  grid-template-columns: 184px 1fr;
}
.incomes-wrapper {
  display: grid;
  grid-template-columns: 2fr 1fr;
}
.incomes-table-color {
  min-width: 8px;
  min-height: 8px;
  border-radius: 100%;
}
.incomes-table-color_disabled {
  background-color: #8AA1AC !important;
}
.incomes-incomes {
  display: grid;
  grid-template-columns: 1fr 80px;
  align-items: end;
  border-bottom: 1px solid #EEEEEE;
}
.incomes-text {
  font-size: 12px;
  line-height: 16px;
}
.incomes-text_dark {
  color: #232323;
}
.incomes-text_grey {
  color: #5f6368;
}
.incomes-date {
  border: 1px solid #8AA1AC;
  border-radius: 5px;
  color: #232323;
  display: flex;
  align-items: center;
  text-transform: none;
  i {
    color: #8AA1AC !important;
  }
}
@media (max-width: 968px) {
  .incomes-wrapper {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 668px) {
  .incomes-chart {
    grid-template-columns: 1fr;
    justify-items: center
  }
}
</style>
